// Component for searching users and apps in the view menu
import React, { useEffect } from "react";
import axios from "axios";
// Context
import GaugeContext from "../../context/gauge/gaugeContext";
// UI
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ListItem from "@material-ui/core/ListItem";

import { allFeatures } from "../../context/FeaturesData";

export default function SearchBars({ selected, grow }) {
	const [users, setUsers] = React.useState();
	const [apps, setApps] = React.useState();
	const gaugeContext = React.useContext(GaugeContext);
	const { nodeColor, setNodeColor } = gaugeContext;

	React.useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		const users = await axios.get("/all_users");
		const apps = await axios.get("/all_apps_short");

		setUsers(users.data);
		setApps(apps.data);
	};

	const handleOnChange = (e) => {
		setNodeColor(e.target.textContent);
	};

	return (
		<>
			<ListItem button variant="outlined">
				<Autocomplete
					onChange={(e) => handleOnChange(e)}
					style={{ width: 300 }}
					options={apps}
					autoHighlight
					renderOption={(option) => (
						<React.Fragment>{option}</React.Fragment>
					)}
					value={
						apps
							? apps.includes(nodeColor)
								? nodeColor
								: null
							: null
					}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Choose an app"
							variant="outlined"
							inputProps={{
								...params.inputProps,
								autoComplete: "new-password",
							}}
						/>
					)}
				/>
			</ListItem>
			<ListItem button variant="outlined">
				<Autocomplete
					onChange={(e) => handleOnChange(e)}
					style={{ width: 300 }}
					options={users}
					autoHighlight
					renderOption={(option) => (
						<React.Fragment>{option}</React.Fragment>
					)}
					value={
						users
							? users.includes(nodeColor)
								? nodeColor
								: null
							: null
					}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Choose a user"
							variant="outlined"
							inputProps={{
								...params.inputProps,
								autoComplete: "new-password",
							}}
						/>
					)}
				/>
			</ListItem>
			<ListItem button variant="outlined">
				<Autocomplete
					onChange={(e) => handleOnChange(e)}
					style={{ width: 300 }}
					options={allFeatures}
					autoHighlight
					renderOption={(option) => (
						<React.Fragment>{option}</React.Fragment>
					)}
					value={
						allFeatures
							? allFeatures.includes(nodeColor)
								? nodeColor
								: null
							: null
					}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Choose a feature"
							variant="outlined"
							inputProps={{
								...params.inputProps,
								autoComplete: "new-password",
							}}
						/>
					)}
				/>
			</ListItem>
		</>
	);
}
